import { render, staticRenderFns } from "./AirwallexNew.vue?vue&type=template&id=90b7f8d8&"
import script from "./AirwallexNew.vue?vue&type=script&lang=js&"
export * from "./AirwallexNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports